export * from "./footer-area";
